import { render, staticRenderFns } from "./AssetCheckListDetailsViewForm.vue?vue&type=template&id=3b06f534"
import script from "./AssetCheckListDetailsViewForm.vue?vue&type=script&lang=js"
export * from "./AssetCheckListDetailsViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports